package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.LayoutResult
import top.wcpe.allincore.ui.runtime.element.Modal
import top.wcpe.allincore.ui.runtime.element.Toast
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.ir.eval.OverlayEvalContext

/**
 * 浮层编排接缝（JS actual）：JS 端无 OverlayLayer / ToastLayer（绑死 IR/eval 层），全部空转。
 */
private object JsOverlayOrchestrator : OverlayOrchestrator {
    override fun renderModalAndMenus(
        root: UIElement<*>,
        layout: LayoutResult,
        bridge: UiRenderBridge,
        registry: RendererRegistry,
        context: RenderContext,
        nowMs: Long,
    ) = Unit

    override fun collectVisibleToasts(root: UIElement<*>): List<Toast> = emptyList()

    override fun renderToasts(declarative: List<Toast>, bridge: UiRenderBridge, nowMs: Long) = Unit

    override fun renderTooltips(
        root: UIElement<*>,
        layout: LayoutResult,
        tooltip: TooltipRenderer.Candidate?,
        bridge: UiRenderBridge,
        registry: RendererRegistry,
        context: RenderContext,
        nowMs: Long,
    ) = Unit

    override fun dispatchOverlayClick(root: UIElement<*>, mx: Double, my: Double, button: Int): Boolean = false

    override fun dispatchOverlayMouseMove(root: UIElement<*>, mx: Double, my: Double): Boolean = false

    override fun dismissTopOverlay(root: UIElement<*>): Boolean = false

    override fun isPointInActiveOverlay(root: UIElement<*>, mx: Double, my: Double): Boolean = false

    override fun activateRightClickMenu(
        root: UIElement<*>,
        path: List<UIElement<*>>,
        absBoxes: List<FloatArray>?,
        mx: Double,
        my: Double,
        ctx: OverlayEvalContext?,
    ): Boolean = false

    override fun activateContextMenu(
        root: UIElement<*>,
        path: List<UIElement<*>>,
        absBoxes: List<FloatArray>?,
        mx: Double,
        my: Double,
        ctx: OverlayEvalContext?,
    ): Boolean = false

    override fun collectVisibleModals(root: UIElement<*>): List<Modal> = emptyList()

    override fun findModalElementBox(
        node: UIElement<*>?,
        layout: LayoutResult,
        targetId: String,
        parentX: Float,
        parentY: Float,
    ): FloatArray? = null
}

internal actual fun overlayOrchestrator(): OverlayOrchestrator = JsOverlayOrchestrator
